import { Page, Text } from '../components/admin-ui';
import TrafficArmorSettings from '../componens/trafficArmorSettings';

export default function TrafficProtection() {
  return <Page>
    <div className="settings-stack">
      <Text as="p" tone="subdued">TrafficArmor checks visits to your storefront product pages.</Text>
      <TrafficArmorSettings />
    </div>
  </Page>;
}
